import { render } from "./EvalvationSubMenu.vue?vue&type=template&id=52a7e57c"
import script from "./EvalvationSubMenu.vue?vue&type=script&lang=js"
export * from "./EvalvationSubMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__